import { styled, flexCenter } from '@unfold/theme';
import { Card } from '@unfold/card';

export const LogoItem = styled(Card)`
  ${flexCenter}
  position: relative;
  cursor: pointer;
  padding: 30px;
  height: 185px;

  &:hover {
    #close-button {
      display: block;
    }
  }
`;

export const Image = styled.img`
  width: 100%;
`;

export const RemoveIconWrapper = styled.div`
  cursor: pointer;
  padding: 5px 5px 2px;
  border-radius: 3px;
  width: 25px;
  height: 26px;
  position: absolute;
  top: 5px;
  right: 5px;
  color: #cacaca;
  display: none;

  svg {
    fill: currentColor;
    g {
      stroke: currentColor;
    }
  }
`;
